import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import signUpSideImageWeb from 'Assets/img/svg/authentication/signup/signUpSideImageWeb.svg';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		margin: {
			margin: 0,
		},
		display: {
			position: 'absolute',
			right: 0,
		},
		background: {
			borderRadius: '3rem',
		},
		side: {
			background: `url(${signUpSideImageWeb})`,
			// height: '100vh',
			width: '40%',
		},
		link: {
			color: '#05042E',
			fontSize: '14px',
			fontFamily: 'Poppins',
		},
		listItems: {
			listStyleType: 'none',
		},
		loginSection: {
			[theme.breakpoints.down('xs')]: {
			},
		},
		error: { fontSize: '12px', color: 'red' },
		positionLogo: {
			position: 'absolute',
			width: '300px',
			height: '200px',
			zIndex: 15,
			top: '50%',
			left: '50%',
			margin: '-100px 0 0 -150px',
			objectFit: 'contain',
		},
	}),
);
